import Axios from "axios";
import {
  SET_BHP_PURCHASE_ORDER_LIST,
  UNSET_BHP_PURCHASE_ORDER_LIST,
} from "@/store/mutation-types";

import { bhpPurchaseOrderResource } from "@/store/api";

const state = {
  getBhpPurchaseOrderList: [],
};

const getters = {
  getBhpPurchaseOrderList(state) {
    return state.getBhpPurchaseOrderList;
  },
};

const mutations = {
  [SET_BHP_PURCHASE_ORDER_LIST](state, data) {
    state.getBhpPurchaseOrderList = data;
  },
  [UNSET_BHP_PURCHASE_ORDER_LIST](state) {
    state.getBhpPurchaseOrderList = [];
  },
};

const actions = {

    getBhpPurchaseOrderList({ commit }, params = {}) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.get(bhpPurchaseOrderResource, { params })
            .then((response) => {
            commit(SET_BHP_PURCHASE_ORDER_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
              commit(UNSET_BHP_PURCHASE_ORDER_LIST);
              reject(error);
            })
            .then((always) => {
              commit("UNSET_LOADING");
            });
        });
    },

    saveBhpPurchaseOrder({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(bhpPurchaseOrderResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateBhpPurchaseOrder({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${bhpPurchaseOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    getBhpPurchaseOrderById({ commit }, { id }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${bhpPurchaseOrderResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

};

export default {
  state,
  getters,
  actions,
  mutations,
};

